module.exports = __webpack_public_path__ + "static/media/poorwill4.50d1aed8.JPG";